/**
 * Shared constants used across the client app.
 *
 * Includes:
 * - Payment method identifiers.
 * - Document type/view identifiers.
 * - Country ISO code constants.
 * - Known invalid product-type combinations.
 * - Shared regular expressions (e.g. VRN validation by character set).
 */
export const PaymentMethod = {
  Monthly: 'Monthly',
  Subscription: 'Subscription',
  Single: 'Single',
  PaymentAssist: 'Subscription Payment'
} as const;

export const DocumentType = {
  IPID: 4,
  Policy: 3
} as const;

export const DocumentView = {
  Mobile: 'mobile',
  Desktop: 'desktop'
} as const;

export const CountryIsoCodes = {
  GB: 'gb',
  ES: 'es',
  DE: 'de',
  AT: 'at'
};
export const InvalidProductTypeCombinations: {
  [key: string]: readonly string[];
} = {
  '40': ['36', '25'],
  '48': ['36', '32']
} as const;

export const TokenRefreshPeriod = 1800; //Half hour window for refrshing front-end token before expiry, in seconds
